export default "<ul class=\"menu-group\">\n  <li *ngFor=\"let menu of menus\">\n    <menu-item [menu]=\"menu\"></menu-item>\n  </li>\n</ul>\n";